/**
 * DFW Home Images Library - SEO-Optimized Unique Images
 * Each image has geo-targeted naming for Google Image Search ranking
 */

export const dfwHomeImages = {
  // Original batch - Collin County premium cities
  plano: {
    url: "https://static.prod-images.emergentagent.com/jobs/04f43ebb-3226-457d-8b8e-07cf7137d9f0/images/3e8108c5537e63be7ea0dabe041edce7ad735951307a00331392fb093f19df76.png",
    alt: "Plano Texas 4 bedroom modern home for sale by owner",
    title: "Modern home in Plano TX - FSBO listing",
    beds: 4,
    style: "modern"
  },
  southlake: {
    url: "https://static.prod-images.emergentagent.com/jobs/04f43ebb-3226-457d-8b8e-07cf7137d9f0/images/fa24dafb67709b921704dd90cd4537391ae4c035e75427db6cf0e682a0c0a485.png",
    alt: "Southlake Texas 5 bedroom luxury estate home for sale",
    title: "Luxury estate in Southlake TX - For sale by owner",
    beds: 5,
    style: "luxury"
  },
  mckinney: {
    url: "https://static.prod-images.emergentagent.com/jobs/04f43ebb-3226-457d-8b8e-07cf7137d9f0/images/202e39b3d5eaccda3ed39db5358b41ce61435619144e7b2f914d49b56b7ba819.png",
    alt: "McKinney Texas 3 bedroom craftsman home for sale by owner",
    title: "Craftsman style home in McKinney TX - FSBO",
    beds: 3,
    style: "craftsman"
  },
  frisco: {
    url: "https://static.prod-images.emergentagent.com/jobs/04f43ebb-3226-457d-8b8e-07cf7137d9f0/images/3df6e61dd07cf0d0deedbd6cc42a492badfa7364e6a99234008ad5a1ed912629.png",
    alt: "Frisco Texas 4 bedroom contemporary home for sale",
    title: "Contemporary home in Frisco TX - For sale by owner",
    beds: 4,
    style: "contemporary"
  },
  allen: {
    url: "https://static.prod-images.emergentagent.com/jobs/04f43ebb-3226-457d-8b8e-07cf7137d9f0/images/37e8a1a7c1e6255a49446fab8081f5623dc56385e84815188a7ba70ad0731674.png",
    alt: "Allen Texas 4 bedroom traditional family home for sale",
    title: "Traditional family home in Allen TX - FSBO listing",
    beds: 4,
    style: "traditional"
  },
  prosper: {
    url: "https://static.prod-images.emergentagent.com/jobs/04f43ebb-3226-457d-8b8e-07cf7137d9f0/images/6f932d8acca9cb7fa82ad70148b94e0010464bbcdaa03cd9c6206ea0aea17dfb.png",
    alt: "Prosper Texas 5 bedroom new construction luxury home",
    title: "New construction home in Prosper TX - For sale by owner",
    beds: 5,
    style: "new-construction"
  },
  
  // Second batch - Tarrant County & Lake cities
  "fort-worth": {
    url: "https://static.prod-images.emergentagent.com/jobs/04f43ebb-3226-457d-8b8e-07cf7137d9f0/images/e92a4652a80531b4799263b143d24e75bf967b81fc3c571d956758fb4cb31621.png",
    alt: "Fort Worth Texas ranch style brick home for sale by owner",
    title: "Ranch home in Fort Worth TX - FSBO listing",
    beds: 4,
    style: "ranch"
  },
  arlington: {
    url: "https://static.prod-images.emergentagent.com/jobs/04f43ebb-3226-457d-8b8e-07cf7137d9f0/images/e0a8b6b7186c3ed15cf70cd7dec60d9afdc0c220972111c1daa0b37d3f9fbf8c.png",
    alt: "Arlington Texas modern townhome for sale near AT&T Stadium",
    title: "Modern townhome in Arlington TX - For sale by owner",
    beds: 3,
    style: "townhome"
  },
  richardson: {
    url: "https://static.prod-images.emergentagent.com/jobs/04f43ebb-3226-457d-8b8e-07cf7137d9f0/images/2f4368e9c807062a1d0610cb7c15a56c3adbd7feb0446be2ebb0025fa0420f07.png",
    alt: "Richardson Texas colonial home for sale established neighborhood",
    title: "Colonial home in Richardson TX - FSBO listing",
    beds: 4,
    style: "colonial"
  },
  grapevine: {
    url: "https://static.prod-images.emergentagent.com/jobs/04f43ebb-3226-457d-8b8e-07cf7137d9f0/images/c37c3cb3ec182362b9a4ae027625eeec6231480916753a786a8a776116450d47.png",
    alt: "Grapevine Texas lakefront home for sale on Grapevine Lake",
    title: "Lakefront property in Grapevine TX - For sale by owner",
    beds: 4,
    style: "lakefront"
  },
  keller: {
    url: "https://static.prod-images.emergentagent.com/jobs/04f43ebb-3226-457d-8b8e-07cf7137d9f0/images/480aa39c3817f01e1ae98ce61e0dbcc97a1722ec2823fb75b8e4da4b91f4d281.png",
    alt: "Keller Texas family home for sale with large backyard",
    title: "Family home in Keller TX - FSBO listing",
    beds: 4,
    style: "family"
  },
  westlake: {
    url: "https://static.prod-images.emergentagent.com/jobs/04f43ebb-3226-457d-8b8e-07cf7137d9f0/images/9547f07770b52a19f5316791b6c7c8eae5df0d6cba574d3e187b207fd4687844.png",
    alt: "Westlake Texas Mediterranean luxury estate for sale",
    title: "Luxury estate in Westlake TX - For sale by owner",
    beds: 6,
    style: "mediterranean"
  },

  // Third batch - More DFW cities
  garland: {
    url: "https://static.prod-images.emergentagent.com/jobs/04f43ebb-3226-457d-8b8e-07cf7137d9f0/images/a7747699799bca2d7e3f20ace7ffd89fe927111e6be63535121dcf8e8b304f48.png",
    alt: "Garland Texas suburban home for sale near Lake Ray Hubbard",
    title: "Suburban home in Garland TX - FSBO listing",
    beds: 4,
    style: "suburban"
  },
  waxahachie: {
    url: "https://static.prod-images.emergentagent.com/jobs/04f43ebb-3226-457d-8b8e-07cf7137d9f0/images/21f0dc96c50c16108878cee4238f749cf2f18248290b66cdfc06fe529cf8f016.png",
    alt: "Waxahachie Texas historic Victorian home for sale",
    title: "Historic Victorian in Waxahachie TX - For sale by owner",
    beds: 4,
    style: "victorian"
  },
  celina: {
    url: "https://static.prod-images.emergentagent.com/jobs/04f43ebb-3226-457d-8b8e-07cf7137d9f0/images/862bd458060c3b531267e50c076b8b34e2167785bc287fa642293d864b8b9fec.png",
    alt: "Celina Texas new construction modern farmhouse for sale",
    title: "New construction farmhouse in Celina TX - FSBO",
    beds: 4,
    style: "farmhouse"
  },
  "highland-park": {
    url: "https://static.prod-images.emergentagent.com/jobs/04f43ebb-3226-457d-8b8e-07cf7137d9f0/images/da0ca08f0f720ef318164563a6c564b7df7ae42f386f0a00b689910c013145d6.png",
    alt: "Highland Park Dallas Texas Georgian mansion for sale",
    title: "Luxury Georgian mansion in Highland Park TX - For sale by owner",
    beds: 6,
    style: "georgian"
  },
  lewisville: {
    url: "https://static.prod-images.emergentagent.com/jobs/04f43ebb-3226-457d-8b8e-07cf7137d9f0/images/d737e7866e3fc166bcf5ed2125012def668b5ccf0f6a4a406cd18ae5be8a46d1.png",
    alt: "Lewisville Texas contemporary home for sale near lake",
    title: "Contemporary lake home in Lewisville TX - FSBO listing",
    beds: 4,
    style: "contemporary"
  },
  weatherford: {
    url: "https://static.prod-images.emergentagent.com/jobs/04f43ebb-3226-457d-8b8e-07cf7137d9f0/images/9798d1747a2490bfd2a2a8272b056a437be320f9f40d671cfbf55fcfb80efad1.png",
    alt: "Weatherford Texas horse ranch estate property for sale",
    title: "Horse ranch estate in Weatherford TX - For sale by owner",
    beds: 4,
    style: "ranch-estate"
  },

  // Fourth batch - More key DFW cities
  denton: {
    url: "https://static.prod-images.emergentagent.com/jobs/04f43ebb-3226-457d-8b8e-07cf7137d9f0/images/5eb6d634ef540685d7975ae7c4b4f2f956439f5ef9717bd10d3a161d05a8cd31.png",
    alt: "Denton Texas craftsman bungalow home for sale near UNT",
    title: "Craftsman home in Denton TX - FSBO listing",
    beds: 3,
    style: "craftsman-bungalow"
  },
  "flower-mound": {
    url: "https://static.prod-images.emergentagent.com/jobs/04f43ebb-3226-457d-8b8e-07cf7137d9f0/images/e3c90413744da7148981c3ed5a9b8a042bcaf8c7fef63b2b013a56bdef8e2fa9.png",
    alt: "Flower Mound Texas executive home for sale master-planned community",
    title: "Executive home in Flower Mound TX - For sale by owner",
    beds: 5,
    style: "executive"
  },
  rockwall: {
    url: "https://static.prod-images.emergentagent.com/jobs/04f43ebb-3226-457d-8b8e-07cf7137d9f0/images/a7c925f3ce32a879f12c0bfe7932a551c47f89e0f459c45cd65c9fccb5e3b39f.png",
    alt: "Rockwall Texas modern lakefront home for sale Lake Ray Hubbard",
    title: "Lakefront home in Rockwall TX - FSBO listing",
    beds: 4,
    style: "modern-lakefront"
  },
  carrollton: {
    url: "https://static.prod-images.emergentagent.com/jobs/04f43ebb-3226-457d-8b8e-07cf7137d9f0/images/3c445d2fa3c18292018e5835adbf99deeab42ff55b3f3edc279966f3b458d130.png",
    alt: "Carrollton Texas traditional family home for sale established neighborhood",
    title: "Traditional home in Carrollton TX - For sale by owner",
    beds: 4,
    style: "traditional"
  },
  addison: {
    url: "https://static.prod-images.emergentagent.com/jobs/04f43ebb-3226-457d-8b8e-07cf7137d9f0/images/3afa9e7d2ba8a4db78ff646b41796eab06102ae9cc79f755870fba17eab8cdaa.png",
    alt: "Addison Texas modern urban townhome for sale walkable neighborhood",
    title: "Urban townhome in Addison TX - FSBO listing",
    beds: 3,
    style: "urban-townhome"
  },
  colleyville: {
    url: "https://static.prod-images.emergentagent.com/jobs/04f43ebb-3226-457d-8b8e-07cf7137d9f0/images/85f59862eb12165d70563bd51f0488b8ac0af06ff2a9b81333a8a28293e39be9.png",
    alt: "Colleyville Texas French country estate mansion for sale",
    title: "French country estate in Colleyville TX - For sale by owner",
    beds: 6,
    style: "french-country"
  },

  // Fifth batch - Dallas County suburbs
  mesquite: {
    url: "https://static.prod-images.emergentagent.com/jobs/04f43ebb-3226-457d-8b8e-07cf7137d9f0/images/c381ee9bfb6bdb9547e5644640f6eef55a850dde14d8b44e0c61a700b3d0d7c4.png",
    alt: "Mesquite Texas brick ranch home for sale established suburb",
    title: "Brick ranch home in Mesquite TX - FSBO listing",
    beds: 3,
    style: "ranch"
  },
  irving: {
    url: "https://static.prod-images.emergentagent.com/jobs/04f43ebb-3226-457d-8b8e-07cf7137d9f0/images/4bb71b86f78f6ab75e0c31d775c8558829c7c18ae7bb35bcc63b95aea0d59904.png",
    alt: "Irving Texas Las Colinas Mediterranean home for sale",
    title: "Mediterranean home in Irving TX Las Colinas - For sale by owner",
    beds: 4,
    style: "mediterranean"
  },
  "grand-prairie": {
    url: "https://static.prod-images.emergentagent.com/jobs/04f43ebb-3226-457d-8b8e-07cf7137d9f0/images/3539abd64802a679dddc6f8f3ba3eecd1bd97d76186efac433fa61a26520b53b.png",
    alt: "Grand Prairie Texas affordable family home for sale",
    title: "Family home in Grand Prairie TX - FSBO listing",
    beds: 4,
    style: "family"
  },
  "the-colony": {
    url: "https://static.prod-images.emergentagent.com/jobs/04f43ebb-3226-457d-8b8e-07cf7137d9f0/images/43bd58033d9814092c0153e897d716d0ad4357587539b7707079e42dc88bd1ed.png",
    alt: "The Colony Texas modern lakeside home for sale Lewisville Lake",
    title: "Modern lakeside home in The Colony TX - For sale by owner",
    beds: 4,
    style: "modern"
  },
  "little-elm": {
    url: "https://static.prod-images.emergentagent.com/jobs/04f43ebb-3226-457d-8b8e-07cf7137d9f0/images/b2f16e68e498170626a388748ac25bce84bce6a21a5b66ad1a9375c2fdb34d08.png",
    alt: "Little Elm Texas lakefront cottage for sale Lewisville Lake",
    title: "Lakefront cottage in Little Elm TX - FSBO listing",
    beds: 3,
    style: "cottage"
  },
  murphy: {
    url: "https://static.prod-images.emergentagent.com/jobs/04f43ebb-3226-457d-8b8e-07cf7137d9f0/images/7d499101797de562e32df66a0896f77f25bcd776fb3c0781f9f8be64ca4575fb.png",
    alt: "Murphy Texas executive colonial home for sale Plano ISD",
    title: "Executive colonial in Murphy TX - For sale by owner",
    beds: 5,
    style: "colonial"
  },

  // Sixth batch - HEB area and more
  euless: {
    url: "https://static.prod-images.emergentagent.com/jobs/04f43ebb-3226-457d-8b8e-07cf7137d9f0/images/b3e7c39e7791fbb6fce80e06db97ab64e871ea9d7eeae24c594060cacdaac4b6.png",
    alt: "Euless Texas mid-century ranch home for sale near DFW Airport",
    title: "Mid-century ranch in Euless TX - FSBO listing",
    beds: 3,
    style: "mid-century"
  },
  bedford: {
    url: "https://static.prod-images.emergentagent.com/jobs/04f43ebb-3226-457d-8b8e-07cf7137d9f0/images/a25eb962fe10bd311ae45fd04678a3369b95c364e6d465d4d5a628e54d53e71f.png",
    alt: "Bedford Texas townhome for sale HEB area",
    title: "Townhome in Bedford TX - For sale by owner",
    beds: 3,
    style: "townhome"
  },
  hurst: {
    url: "https://static.prod-images.emergentagent.com/jobs/04f43ebb-3226-457d-8b8e-07cf7137d9f0/images/737e0d0307c4172da5086dc4830399e4697cd8aa8a28734ad8ab856e9b65af8a.png",
    alt: "Hurst Texas traditional family home for sale",
    title: "Traditional family home in Hurst TX - FSBO listing",
    beds: 4,
    style: "traditional"
  },
  forney: {
    url: "https://static.prod-images.emergentagent.com/jobs/04f43ebb-3226-457d-8b8e-07cf7137d9f0/images/e1fd0c2ba90a24637478225a36f4e90b0d161bad2665ca9164e30568fb44c27c.png",
    alt: "Forney Texas new construction starter home for sale",
    title: "New construction home in Forney TX - For sale by owner",
    beds: 3,
    style: "new-construction"
  },
  granbury: {
    url: "https://static.prod-images.emergentagent.com/jobs/04f43ebb-3226-457d-8b8e-07cf7137d9f0/images/d1b05ffac79316021e711260fc6393667cc205dee7c80873aa4f8161769fa292.png",
    alt: "Granbury Texas Victorian lakeside cottage for sale",
    title: "Victorian lakeside home in Granbury TX - FSBO listing",
    beds: 3,
    style: "victorian"
  },
  "north-richland-hills": {
    url: "https://static.prod-images.emergentagent.com/jobs/04f43ebb-3226-457d-8b8e-07cf7137d9f0/images/400281bd9d7af7eae96cbbf263e620e9bd606addbe26f0e5670e61550da461a3.png",
    alt: "North Richland Hills Texas split-level home with pool for sale",
    title: "Split-level home with pool in NRH TX - For sale by owner",
    beds: 4,
    style: "split-level"
  },

  // Seventh batch - More suburbs
  "cedar-hill": {
    url: "https://static.prod-images.emergentagent.com/jobs/04f43ebb-3226-457d-8b8e-07cf7137d9f0/images/ba1d0233fa7cbaa50d1400dc06f2aeaf3fcf5886bf643a6c0df8f28242fffa59.png",
    alt: "Cedar Hill Texas hillside home for sale near state park",
    title: "Hillside home in Cedar Hill TX - FSBO listing",
    beds: 4,
    style: "hillside"
  },
  "highland-village": {
    url: "https://static.prod-images.emergentagent.com/jobs/04f43ebb-3226-457d-8b8e-07cf7137d9f0/images/b3ebc5378b1851046a63300bf01c54668ab009653752b16cc6e5fb8c95aa1000.png",
    alt: "Highland Village Texas lakeside colonial home for sale",
    title: "Lakeside colonial in Highland Village TX - For sale by owner",
    beds: 5,
    style: "colonial"
  },
  desoto: {
    url: "https://static.prod-images.emergentagent.com/jobs/04f43ebb-3226-457d-8b8e-07cf7137d9f0/images/f3c3bcd0c711162b2f4ed25218063b3b542f2f675fc7e42b182975654421de62.png",
    alt: "DeSoto Texas updated ranch home for sale",
    title: "Updated ranch home in DeSoto TX - FSBO listing",
    beds: 3,
    style: "ranch"
  },
  anna: {
    url: "https://static.prod-images.emergentagent.com/jobs/04f43ebb-3226-457d-8b8e-07cf7137d9f0/images/c4d764cc39e06f099dc771e657e2c012197aada7b995ba0449bd29ca996c95a0.png",
    alt: "Anna Texas modern farmhouse new construction for sale",
    title: "Modern farmhouse in Anna TX - For sale by owner",
    beds: 4,
    style: "farmhouse"
  },
  wylie: {
    url: "https://static.prod-images.emergentagent.com/jobs/04f43ebb-3226-457d-8b8e-07cf7137d9f0/images/5bc6ca820997b73b046a56e731a81c667de2ecd7f7d7993ae750db6d1c755d22.png",
    alt: "Wylie Texas Lake Lavon waterfront home for sale",
    title: "Waterfront home in Wylie TX - FSBO listing",
    beds: 4,
    style: "waterfront"
  },
  "university-park": {
    url: "https://static.prod-images.emergentagent.com/jobs/04f43ebb-3226-457d-8b8e-07cf7137d9f0/images/7292e1048592c57b5ebb2a455053383b83015651c856456eb8357595d29ceebf.png",
    alt: "University Park Dallas Texas Tudor mansion for sale near SMU",
    title: "Tudor mansion in University Park TX - For sale by owner",
    beds: 6,
    style: "tudor"
  },

  // Eighth batch - More cities
  rowlett: {
    url: "https://static.prod-images.emergentagent.com/jobs/04f43ebb-3226-457d-8b8e-07cf7137d9f0/images/af089c97856f0323fc18b17c8694139277add94fbe3781779b703a824f0f5dab.png",
    alt: "Rowlett Texas lakeside traditional home for sale Lake Ray Hubbard",
    title: "Lakeside home in Rowlett TX - FSBO listing",
    beds: 4,
    style: "traditional"
  },
  coppell: {
    url: "https://static.prod-images.emergentagent.com/jobs/04f43ebb-3226-457d-8b8e-07cf7137d9f0/images/eb9eccebca89d2b5d0a4a05a1eaa867ed0e4a01eb4b4ff8635efbc2c2c54b71a.png",
    alt: "Coppell Texas premium colonial home for sale Coppell ISD",
    title: "Colonial home in Coppell TX - For sale by owner",
    beds: 5,
    style: "colonial"
  },
  fate: {
    url: "https://static.prod-images.emergentagent.com/jobs/04f43ebb-3226-457d-8b8e-07cf7137d9f0/images/c624f4a91f55449ba50db4185d42c038dab266bb1c6c6c8250d3e04f94eaafa3.png",
    alt: "Fate Texas new construction starter home for sale Rockwall County",
    title: "New construction home in Fate TX - FSBO listing",
    beds: 3,
    style: "new-construction"
  },
  mansfield: {
    url: "https://static.prod-images.emergentagent.com/jobs/04f43ebb-3226-457d-8b8e-07cf7137d9f0/images/5639f38838f5788384953e8e400b50631708fa1601b62ebde48f2d08a710d197.png",
    alt: "Mansfield Texas traditional brick home for sale Mansfield ISD",
    title: "Traditional brick home in Mansfield TX - For sale by owner",
    beds: 4,
    style: "traditional"
  },
  burleson: {
    url: "https://static.prod-images.emergentagent.com/jobs/04f43ebb-3226-457d-8b8e-07cf7137d9f0/images/8b71ee4102ae3553ed67d318e070d5efc1199fa91cab44cac45c0137ba062690.png",
    alt: "Burleson Texas affordable ranch home for sale south Fort Worth",
    title: "Ranch home in Burleson TX - FSBO listing",
    beds: 3,
    style: "ranch"
  },

  // Ninth batch - Additional cities (Feb 2026)
  dallas: {
    url: "https://static.prod-images.emergentagent.com/jobs/a9c4542b-e3ee-4f52-9329-2ef5ef7d0943/images/1862686878f60805c52444ab6d6e82305d62c0a4817185e9faa359188e6fa03d.png",
    alt: "Dallas Texas 4 bedroom modern brick home uptown for sale by owner",
    title: "Modern home in Dallas TX - FSBO listing",
    beds: 4,
    style: "modern"
  },
  "flower-mound": {
    url: "https://static.prod-images.emergentagent.com/jobs/a9c4542b-e3ee-4f52-9329-2ef5ef7d0943/images/c67cd6758a10392c4698810474e164e172fe7cebdadbca3230c37e97d322485e.png",
    alt: "Flower Mound Texas 5 bedroom Mediterranean estate home for sale",
    title: "Mediterranean estate in Flower Mound TX - For sale by owner",
    beds: 5,
    style: "mediterranean"
  },
  "grand-prairie": {
    url: "https://static.prod-images.emergentagent.com/jobs/a9c4542b-e3ee-4f52-9329-2ef5ef7d0943/images/29f308d47676f9c1c2c6725822b852891187a9f359d3bd2fb34be326bf8777da.png",
    alt: "Grand Prairie Texas 3 bedroom ranch home for sale suburban family neighborhood",
    title: "Ranch home in Grand Prairie TX - FSBO listing",
    beds: 3,
    style: "ranch"
  },
  "highland-park": {
    url: "https://static.prod-images.emergentagent.com/jobs/a9c4542b-e3ee-4f52-9329-2ef5ef7d0943/images/8d902755f909a3600a4831fc72ab6c11a7f841acd20d278006da3d31c00c417e.png",
    alt: "Highland Park Texas 6 bedroom Georgian colonial mansion for sale",
    title: "Georgian mansion in Highland Park TX - For sale by owner",
    beds: 6,
    style: "colonial"
  },
  "little-elm": {
    url: "https://static.prod-images.emergentagent.com/jobs/a9c4542b-e3ee-4f52-9329-2ef5ef7d0943/images/da72fb64c06e553db287bce47f484fc732eef318eb87fa6a76daf88821010e01.png",
    alt: "Little Elm Texas 4 bedroom lakeside home for sale Lewisville Lake",
    title: "Lakefront home in Little Elm TX - FSBO listing",
    beds: 4,
    style: "lakefront"
  },
  "north-richland-hills": {
    url: "https://static.prod-images.emergentagent.com/jobs/a9c4542b-e3ee-4f52-9329-2ef5ef7d0943/images/e8db6efe9758f10a353309c233bed0b6b1bacec4e7518e3ca2c6b4136a61a8d1.png",
    alt: "North Richland Hills Texas 4 bedroom traditional two-story home for sale",
    title: "Traditional home in North Richland Hills TX - For sale by owner",
    beds: 4,
    style: "traditional"
  },
  duncanville: {
    url: "https://static.prod-images.emergentagent.com/jobs/a9c4542b-e3ee-4f52-9329-2ef5ef7d0943/images/e0dd54b58ca4e5e5ecbf4b4b7e82fabebb95a1eadab4fe4dca33c0f93fd47da4.png",
    alt: "Duncanville Texas 4 bedroom Tudor brick home for sale established neighborhood",
    title: "Tudor home in Duncanville TX - FSBO listing",
    beds: 4,
    style: "tudor"
  },
  "farmers-branch": {
    url: "https://static.prod-images.emergentagent.com/jobs/a9c4542b-e3ee-4f52-9329-2ef5ef7d0943/images/3d62ec16df91bf8664a657844ac57ec09b2de4715616bcd47bfab2336a27db2c.png",
    alt: "Farmers Branch Texas 3 bedroom cottage craftsman home for sale",
    title: "Cottage home in Farmers Branch TX - For sale by owner",
    beds: 3,
    style: "cottage"
  },
  midlothian: {
    url: "https://static.prod-images.emergentagent.com/jobs/a9c4542b-e3ee-4f52-9329-2ef5ef7d0943/images/05e3a65d11c3a6cfc8cca817b44094eed9ab94d75e4dfac6a80f8391b40d7166.png",
    alt: "Midlothian Texas 4 bedroom modern home for sale Hill Country views",
    title: "Modern home in Midlothian TX - FSBO listing",
    beds: 4,
    style: "modern"
  },
  lancaster: {
    url: "https://static.prod-images.emergentagent.com/jobs/a9c4542b-e3ee-4f52-9329-2ef5ef7d0943/images/58ec3c81d5e1b76ed5232ca3bc0c935f62f19176a172ba4d8d43a7537469a50a.png",
    alt: "Lancaster Texas 5 bedroom colonial brick home for sale",
    title: "Colonial home in Lancaster TX - For sale by owner",
    beds: 5,
    style: "colonial"
  },
  melissa: {
    url: "https://static.prod-images.emergentagent.com/jobs/a9c4542b-e3ee-4f52-9329-2ef5ef7d0943/images/ff2cfd6aa3689b5f63fa231d591528f83745f0a0074b76f857edc44931b6fe24.png",
    alt: "Melissa Texas 3 bedroom contemporary starter home for sale new development",
    title: "Starter home in Melissa TX - FSBO listing",
    beds: 3,
    style: "contemporary"
  },
  argyle: {
    url: "https://static.prod-images.emergentagent.com/jobs/a9c4542b-e3ee-4f52-9329-2ef5ef7d0943/images/763c3a408b7481de9d2ce8ab48ff0e23a492b3b2d8de8306ee43950ccc832b67.png",
    alt: "Argyle Texas 4 bedroom country home for sale horse property acreage",
    title: "Country estate in Argyle TX - For sale by owner",
    beds: 4,
    style: "country"
  },

  // Tenth batch - More cities (Feb 2026)
  aledo: {
    url: "https://static.prod-images.emergentagent.com/jobs/a9c4542b-e3ee-4f52-9329-2ef5ef7d0943/images/3588ff97ca859a5797a647ac469646a68e44127839a001e5260d1c3c10990967.png",
    alt: "Aledo Texas 3 bedroom stone cottage home for sale Parker County",
    title: "Stone cottage in Aledo TX - FSBO listing",
    beds: 3,
    style: "cottage"
  },
  aubrey: {
    url: "https://static.prod-images.emergentagent.com/jobs/a9c4542b-e3ee-4f52-9329-2ef5ef7d0943/images/564fec0ca0406b817ed38368ff8ba0dbc46e268d89c719a4fddbf7d0dae15e04.png",
    alt: "Aubrey Texas 4 bedroom modern farmhouse new construction for sale",
    title: "Farmhouse in Aubrey TX - For sale by owner",
    beds: 4,
    style: "farmhouse"
  },
  benbrook: {
    url: "https://static.prod-images.emergentagent.com/jobs/a9c4542b-e3ee-4f52-9329-2ef5ef7d0943/images/88bd4c8fa50e81d56ff4d1731cb4cf317935b6ccd1dab283e5e42a0cff40428b.png",
    alt: "Benbrook Texas 3 bedroom traditional brick home near Benbrook Lake",
    title: "Traditional home in Benbrook TX - FSBO listing",
    beds: 3,
    style: "traditional"
  },
  cleburne: {
    url: "https://static.prod-images.emergentagent.com/jobs/a9c4542b-e3ee-4f52-9329-2ef5ef7d0943/images/bb0e8c0feb050621f7e2f5eb8c3f213b53757854bb8fcec1e7dd6fb7d9ace419.png",
    alt: "Cleburne Texas 4 bedroom Hill Country style home for sale Johnson County",
    title: "Hill Country home in Cleburne TX - For sale by owner",
    beds: 4,
    style: "hill-country"
  },
  corinth: {
    url: "https://static.prod-images.emergentagent.com/jobs/a9c4542b-e3ee-4f52-9329-2ef5ef7d0943/images/1cde34c379859291347a20f268cf45d53dd3cc83948bc0b1ed917cfb31e050dc.png",
    alt: "Corinth Texas 3 bedroom modern two-story home for sale Denton County",
    title: "Modern home in Corinth TX - FSBO listing",
    beds: 3,
    style: "modern"
  },
  crowley: {
    url: "https://static.prod-images.emergentagent.com/jobs/a9c4542b-e3ee-4f52-9329-2ef5ef7d0943/images/57bbd7f7760d86aa3516840236dae28f963f876756ea370112a0ec8310ad3914.png",
    alt: "Crowley Texas 3 bedroom affordable ranch home for sale south Fort Worth",
    title: "Starter home in Crowley TX - For sale by owner",
    beds: 3,
    style: "ranch"
  },
  decatur: {
    url: "https://static.prod-images.emergentagent.com/jobs/a9c4542b-e3ee-4f52-9329-2ef5ef7d0943/images/e38682b97c563b21e9ccdc80158e1137817fb2be9722e199e4ae690f76192485.png",
    alt: "Decatur Texas 4 bedroom Victorian home for sale Wise County historic",
    title: "Victorian home in Decatur TX - FSBO listing",
    beds: 4,
    style: "victorian"
  },
  ennis: {
    url: "https://static.prod-images.emergentagent.com/jobs/a9c4542b-e3ee-4f52-9329-2ef5ef7d0943/images/521a519ede5d366ca5412afd6e5b52c48ac015ab20bee898636c36855658454f.png",
    alt: "Ennis Texas 3 bedroom brick ranch home for sale Ellis County",
    title: "Ranch home in Ennis TX - For sale by owner",
    beds: 3,
    style: "ranch"
  },
  fairview: {
    url: "https://static.prod-images.emergentagent.com/jobs/a9c4542b-e3ee-4f52-9329-2ef5ef7d0943/images/faddfd051b802cee2eabddbe7341fee66f893cb2af6887997f6edd9d17b448c6.png",
    alt: "Fairview Texas 4 bedroom executive home for sale Lovejoy ISD Collin County",
    title: "Executive home in Fairview TX - FSBO listing",
    beds: 4,
    style: "executive"
  },
  "haltom-city": {
    url: "https://static.prod-images.emergentagent.com/jobs/a9c4542b-e3ee-4f52-9329-2ef5ef7d0943/images/8f1653663fef11af54d7dce277fd18ea25cf17fbfc19e98d8d3ef0c5d3b0f98d.png",
    alt: "Haltom City Texas 3 bedroom modern townhome for sale near Fort Worth",
    title: "Townhome in Haltom City TX - For sale by owner",
    beds: 3,
    style: "townhome"
  },
  heath: {
    url: "https://static.prod-images.emergentagent.com/jobs/a9c4542b-e3ee-4f52-9329-2ef5ef7d0943/images/2b118e502dad8d154db26827525a770fe6eb12f5ff1a1a00c7d07de4a741f957.png",
    alt: "Heath Texas 4 bedroom lakefront home for sale Lake Ray Hubbard Rockwall County",
    title: "Lakefront home in Heath TX - FSBO listing",
    beds: 4,
    style: "lakefront"
  },
  princeton: {
    url: "https://static.prod-images.emergentagent.com/jobs/a9c4542b-e3ee-4f52-9329-2ef5ef7d0943/images/d0550c5fbf6cab69aa80065ba84485b5582cc8abb9d9424ad2add3908ee7b6ab.png",
    alt: "Princeton Texas 4 bedroom new construction home for sale Collin County",
    title: "New construction in Princeton TX - For sale by owner",
    beds: 4,
    style: "new-construction"
  },
  "glenn-heights": {
    url: "https://static.prod-images.emergentagent.com/jobs/a9c4542b-e3ee-4f52-9329-2ef5ef7d0943/images/c0c96f17f52f939c2d11b88485cc6681c115dc774ff234269d4339d6c378d9c3.png",
    alt: "Glenn Heights Texas 3 bedroom brick starter home for sale Ellis County",
    title: "Starter home in Glenn Heights TX - FSBO listing",
    beds: 3,
    style: "traditional"
  },
  "red-oak": {
    url: "https://static.prod-images.emergentagent.com/jobs/a9c4542b-e3ee-4f52-9329-2ef5ef7d0943/images/402c0c602075f006680e15b469ef8f15f649e36b88018401e5d0088e56fcab21.png",
    alt: "Red Oak Texas 3 bedroom traditional brick home for sale Ellis County",
    title: "Traditional home in Red Oak TX - For sale by owner",
    beds: 3,
    style: "traditional"
  },
  roanoke: {
    url: "https://static.prod-images.emergentagent.com/jobs/a9c4542b-e3ee-4f52-9329-2ef5ef7d0943/images/ab4efdcec516e04b92581b02a307061f01e92c455b52b1548488430b07109d1e.png",
    alt: "Roanoke Texas 4 bedroom upscale home for sale Denton County",
    title: "Upscale home in Roanoke TX - FSBO listing",
    beds: 4,
    style: "luxury"
  },
  "royse-city": {
    url: "https://static.prod-images.emergentagent.com/jobs/a9c4542b-e3ee-4f52-9329-2ef5ef7d0943/images/2112d0b4d6b0282b056365a1d3f873004d256ca643789be80293bb26001e9004.png",
    alt: "Royse City Texas 4 bedroom new construction home for sale Rockwall County",
    title: "New construction in Royse City TX - For sale by owner",
    beds: 4,
    style: "new-construction"
  },
  "trophy-club": {
    url: "https://static.prod-images.emergentagent.com/jobs/a9c4542b-e3ee-4f52-9329-2ef5ef7d0943/images/e9f843a5a4db068dd88d1131941c0679203ee16102759a5bc792e0ec16e0082f.png",
    alt: "Trophy Club Texas 5 bedroom luxury estate home for sale golf course community",
    title: "Luxury estate in Trophy Club TX - FSBO listing",
    beds: 5,
    style: "mediterranean"
  },
  "willow-park": {
    url: "https://static.prod-images.emergentagent.com/jobs/a9c4542b-e3ee-4f52-9329-2ef5ef7d0943/images/61595a4a891ecf46efc0ee912aa8cc4d92f44adacd31f283cbd8760d7a63f5a0.png",
    alt: "Willow Park Texas 4 bedroom home for sale Parker County Hill Country views",
    title: "Hill Country home in Willow Park TX - For sale by owner",
    beds: 4,
    style: "hill-country"
  },
  sanger: {
    url: "https://static.prod-images.emergentagent.com/jobs/a9c4542b-e3ee-4f52-9329-2ef5ef7d0943/images/e7266f99001f908b580e5e050a5822dfafc0403541aa67253ab319a1b645c345.png",
    alt: "Sanger Texas 3 bedroom farmhouse home for sale Denton County country living",
    title: "Farmhouse in Sanger TX - FSBO listing",
    beds: 3,
    style: "farmhouse"
  },
  terrell: {
    url: "https://static.prod-images.emergentagent.com/jobs/a9c4542b-e3ee-4f52-9329-2ef5ef7d0943/images/2a4d1ff54e1ed8a954b4d62c9ddafc3132ef69a5cb9d28bdb4155e9f7c4e7caf.png",
    alt: "Terrell Texas 4 bedroom brick home for sale Kaufman County east of Dallas",
    title: "Family home in Terrell TX - For sale by owner",
    beds: 4,
    style: "traditional"
  },
  saginaw: {
    url: "https://static.prod-images.emergentagent.com/jobs/04f43ebb-3226-457d-8b8e-07cf7137d9f0/images/1f8c73ae0ee99e5fc1f64b7dc6ab7c5654e0f6159ece4836ca741aca4df685f3.png",
    alt: "Saginaw Texas newer construction home for sale Eagle Mountain area",
    title: "Newer construction home in Saginaw TX - For sale by owner",
    beds: 4,
    style: "new-construction"
  }
};

// Interior room images for listings
export const interiorImages = {
  kitchen: {
    url: "https://static.prod-images.emergentagent.com/jobs/04f43ebb-3226-457d-8b8e-07cf7137d9f0/images/85169ba91dcb95ccd75d9abc06e68f5adcaf818979164479957e1666dad5e537.png",
    alt: "Modern Texas kitchen with granite countertops and large island",
    title: "Gourmet kitchen - Texas home for sale"
  },
  bathroom: {
    url: "https://static.prod-images.emergentagent.com/jobs/04f43ebb-3226-457d-8b8e-07cf7137d9f0/images/e1f8ee446ea5dd3562d617f7f1f5ada7b9995816519dbb513dba4630d4999e4a.png",
    alt: "Luxury master bathroom with dual vanities and soaking tub",
    title: "Spa-like master bathroom - Texas home"
  },
  livingRoom: {
    url: "https://static.prod-images.emergentagent.com/jobs/04f43ebb-3226-457d-8b8e-07cf7137d9f0/images/45924833815053a3d6fbb189ba286ee327c64b39d0e8368cc951ebd7b645a881.png",
    alt: "Spacious living room with fireplace and high ceilings Texas home",
    title: "Open concept living room - Texas home for sale"
  },
  backyard: {
    url: "https://static.prod-images.emergentagent.com/jobs/04f43ebb-3226-457d-8b8e-07cf7137d9f0/images/60286c3af847d02bb5e8fc17ccef9d7fcfcb998268f1bfe136f366576972284d.png",
    alt: "Texas backyard with pool covered patio and outdoor kitchen",
    title: "Resort-style backyard - Texas home"
  },
  bedroom: {
    url: "https://static.prod-images.emergentagent.com/jobs/04f43ebb-3226-457d-8b8e-07cf7137d9f0/images/7de4830c8da9201c9b47b59834269c43561932485666bdbdef687235b1ece8f4.png",
    alt: "Spacious master bedroom with walk-in closet Texas home",
    title: "Master suite - Texas home for sale"
  },
  office: {
    url: "https://static.prod-images.emergentagent.com/jobs/04f43ebb-3226-457d-8b8e-07cf7137d9f0/images/08c4e5bd7d95097a36f82fd3d1a64e3aa60fe3157b24b8fffcc18349de9f1ccc.png",
    alt: "Home office with built-in bookshelves Texas property",
    title: "Work from home office - Texas home"
  }
};

// Get interior image by room type
export const getInteriorImage = (roomType) => interiorImages[roomType] || interiorImages.livingRoom;

// Get image for a specific city (with fallback)
export const getCityImage = (citySlug) => {
  return dfwHomeImages[citySlug] || dfwHomeImages.plano;
};

// Get all available city images
export const getAllCityImages = () => Object.entries(dfwHomeImages);

// Get images by style
export const getImagesByStyle = (style) => {
  return Object.entries(dfwHomeImages).filter(([_, img]) => img.style === style);
};

// Get random unique images (for listings without specific city)
export const getRandomImages = (count = 6) => {
  const images = Object.values(dfwHomeImages);
  const shuffled = [...images].sort(() => Math.random() - 0.5);
  return shuffled.slice(0, count);
};
